export const actionTypes = {
  SHOW_AND_CLOSE_SIDEBAR: "SHOW_AND_CLOSE_SIDEBAR",
};

export const showAndCloseSidebar = (show: boolean) => ({
  type: actionTypes.SHOW_AND_CLOSE_SIDEBAR,
  show,
});
